import React, {useCallback, useMemo} from "react";
import {useNavigate} from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DonutsCard from "./sub-components/donutCards";
import {ToScreenSkeleton} from "../screening/sub-components/skeleton";

const ToTest = ({
                    currentPage,
                    startDate,
                    endDate,
                    setCurrentPage,
                    allTestingList,
                    isTestingLoading,
                }) => {
    const navigate = useNavigate();
    const handleChangePage = useCallback(() => {
        setCurrentPage((prev) => prev + 1);
    }, [setCurrentPage]);

    const handleNavigate = useCallback((user) => {
        navigate("/testing/details-view", {state: {user, startDate, endDate}})
    }, [navigate, startDate, endDate])

    const users = useMemo(() => allTestingList?.users || [], [allTestingList]);
    const totalCount = allTestingList?.totalCount ?? 0;

    if (isTestingLoading) {
        return (
            <>
                <p className="secondHeader">Testing</p>
                <Row>
                    <ToScreenSkeleton/>
                </Row>
            </>
        );
    }

    if (!users.length) {
        return (
            <>
                <p className="secondHeader">Testing</p>
                <Row>
                    <img
                        alt="No data found"
                        src="no-data.gif"
                        style={{
                            width: "200px",
                            display: "block",
                            margin: "0 auto",
                            objectFit: "contain",
                        }}
                        />
                </Row>
            </>
        );
    }

    return (
        <>
            <p className="secondHeader">Testing</p>
            <Row>
                {users.map((user, i) => (
                    <Col
                        xl={4}
                        xxl={4}
                        lg={4}
                        md={6}
                        xs={12}
                        sm={12}
                        key={user.id || i}
                        onClick={() => { handleNavigate(user)}}
                        style={{cursor: "pointer"}}
                    >
                        <DonutsCard left="Daily Average" last="High Score" user={user}/>
                    </Col>
                ))}
                {users.length < totalCount && (
                    <p
                        className="secondHeader"
                        style={{cursor: "pointer"}}
                        onClick={handleChangePage}
                        >Load More</p>
                )}
            </Row>
        </>
    );
};

export default ToTest;
